/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backdrop_PreviewInputs */

const en_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backdrop Preview`)
};

const es_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa del fondo`)
};

const fr_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu de la toile de fond`)
};

const de_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrund-Vorschau`)
};

const ja_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背景プレビュー`)
};

const zh_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背景预览`)
};

const ar_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معاينة الخلفية`)
};

const id_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratinjau Latar Belakang`)
};

const it_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima dello Sfondo`)
};

const ru_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предпросмотр фона`)
};

const pt_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização do Fundo`)
};

const ko_backdrop_preview = /** @type {(inputs: Backdrop_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배경 이미지 미리보기`)
};

/**
* | output |
* | --- |
* | "Backdrop Preview" |
*
* @param {Backdrop_PreviewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const backdrop_preview = /** @type {((inputs?: Backdrop_PreviewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backdrop_PreviewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backdrop_preview(inputs)
	if (locale === "es") return es_backdrop_preview(inputs)
	if (locale === "fr") return fr_backdrop_preview(inputs)
	if (locale === "de") return de_backdrop_preview(inputs)
	if (locale === "ja") return ja_backdrop_preview(inputs)
	if (locale === "zh") return zh_backdrop_preview(inputs)
	if (locale === "ar") return ar_backdrop_preview(inputs)
	if (locale === "id") return id_backdrop_preview(inputs)
	if (locale === "it") return it_backdrop_preview(inputs)
	if (locale === "ru") return ru_backdrop_preview(inputs)
	if (locale === "pt") return pt_backdrop_preview(inputs)
	return ko_backdrop_preview(inputs)
});